<template>
  <div class="testData">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.TEST') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.ReportsDetail.Test_photo') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '',
              mediaType: '',
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
          <!-- <img
            v-for="img in item.media"
            :key="img.id"
            :src="config.baseUrlImg + img.mediaPath"
          /> -->
          <!-- <img src="../../../../assets/image/noImg.png" /> -->
        </div>
      </div>
      <div class="ceshi1">
        <div>
          <span class="spanImage">{{
            $tc('lang.ReportsDetail.Field_Test')
          }}</span>
          <span>{{ item.testitem.testitemField }}</span>
        </div>
        <div>
          <span class="spanImage">{{
            $tc('lang.ReportsDetail.Test_Requirement')
          }}</span>
          <span>{{ item.testitem.testitemRequire }}</span>
        </div>
        <div>
          <span class="spanImage">{{
            $tc('lang.ReportsDetail.Quantity')
          }}</span>
          <span>{{ item.testitem.testitemQuantity }}</span>
        </div>
        <div>
          <span class="spanImage">{{
            $tc('lang.ReportsDetail.Conclude')
          }}</span>
          <span v-if="item.testitem.testitemConclude == 1">通过</span>
          <span v-else-if="item.testitem.testitemConclude == 3">不通过</span>
          <span v-else></span>
        </div>
      </div>
      <!-- <div class="desOfGoods-table">
        <a-table
          class="desOfGoods-table1"
          :columns="columns"
          :dataSource="data"
          bordered
          :pagination="false"
        >
          <template slot="footer">
            <p>
              <span>备注：</span>
              <span>123</span>
            </p>
          </template>
        </a-table>
      </div> -->
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
const columns = [
  {
    title: '测试项目',
    dataIndex: 'street',
    key: 'street',
  },
  {
    title: '测试要求',
    dataIndex: 'street1',
    key: 'street1',
  },
  {
    title: '抽样数量',
    dataIndex: 'street2',
    key: 'street2',
  },
  {
    title: '结论',
    dataIndex: 'street3',
    key: 'street3',
  },
];
const data = [
  {
    street: 12,
    street7: 23112,
    street1: 321,
    street2: 312,
    street3: 312,
    street4: 312,
    street5: 312,
  },
];
export default {
  data() {
    return {
      columns,
      data,
    };
  },
  components: {
    showImg,
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
    },
    // imgList: {
    //   get() {
    //     return this.$store.state.report.imgList;
    //   },
    //   set(val) {
    //     this.$store.commit('report/save', { imgList: val });
    //   },
    // },
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      // console.log(this.details);
      // return;
      this.$http
        .post('/hzwmj/inspect-testitem/selectDate', {
          orderNo: this.details.orderId,
          reportNo: this.details.ireportId,
        })
        .then(data => {
          console.log('data', data);
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
  },
};
</script>
<style lang="less">
.testData {
  .desOfGoods-con {
    .spanImage {
      text-align: left;
    }
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .ceshi1 {
    > div {
      margin-bottom: 10px;
      text-align: left;
    }
    span:nth-child(1) {
      display: inline-block;
      width: 120px;
      padding-left: 20px;
    }
  }
  .productProcess-list {
    margin-bottom: 40px;
  }
  // .desOfGoods-table {
  //   display: flex;
  //   .desOfGoods-table1 {
  //     flex-grow: 1;
  //     margin-left: 20px;
  //     .ant-table-footer {
  //       padding: 0;
  //       .footer1 {
  //         border-right: 1px solid #e8e8e8;
  //         width: 30%;
  //       }
  //       p {
  //         display: inline-block;
  //         padding: 0 16px;
  //         margin-bottom: 0;
  //         line-height: 52px;
  //       }
  //     }
  //   }
  //   .button-group {
  //     width: 130px;
  //     flex-shrink: 0;
  //   }
  // }
}
</style>
